import script from "./PauseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PauseModal.vue?vue&type=script&setup=true&lang=ts"

import "./PauseModal.vue?vue&type=style&index=0&id=279599e7&lang=css"

const __exports__ = script;

export default __exports__